import {
  Jeans,
  C3PO,
  Car,
  R2D2,
  Falcon
} from 'media/icons';

const facts=[
  {
    title:'Skywalker\'s jeans',
    detail:'For its time, Star Wars: A New Hope was an impressive feat of special effects. Apparently this didn’t apply towards the cast’s wardrobe. “The pants I wore in the first film were just Levi blue jeans bleachedout, with the back pockets removed,” Hamill tweeted. “George (Lucas) called Star Wars the most expensive low-budget movie ever made and every penny spent had to show up on the screen. I think they started with my costume.”',
    image:Jeans,
    imageType:'svg'
  },
  {
    title:'A droid with a soul',
    detail:'Yes, there is an actual human being walking around in that metallic C-3PO droid costume. It’s actor Anthony Daniels. As you can probably imagine, it wasn’t the most comfortable of togs to wear on set; in detail, Daniels couldn’t sit down while wearing the contraption.',
    image:C3PO,
    imageType:'svg'
  },
  {
    title:'Maserati Podracer',
    detail:'Although The Phantom Menace, which hit theaters in 1999, was largely panned by both film critics and fans, there are still some little behind-the-scenes fun details that might surprise followers of the space opera saga. After all, the entire franchise has produced some pretty fierce vehicles for the characters to use. In this film, Anakin Skywalker drives a Podracer, which was actually constructed from the shell of a Maserati Birdcage. This was a racing car first introduced in the 1960s, making its design a bit of a vintage ride as young Skywalker raced across Tatooine.',
    image:Car,
    imageType:'svg'
  },
  {
    title:'Robot Feuds',
    detail:'C-3PO and R2-D2 may have been best buddies on-screen, but off-camera the actors who played the droids allegedly despised one another. According to Hollywood.com, Kenny Baker, the actor who portrayed R2-D2, referred to Anthony Daniels (C-3PO) as rude.',
    image:R2D2,
    imageType:'svg'
  },
  {
    title:'Save the falcon',
    detail:'Harrison Ford’s Han Solo may have been the pilot of the Millennium Falcon, but on set Ford got so angry with the way production was going he actually took a saw to the beloved ship. “You heard about Harrison taking a saw to the Millennium Falcon because he got so mad?” Hamill mentioned in an interview with Empire. “People were coming up to me going, ‘You gotta stop Harrison, he’s sawing up the Falcon.’ It was made of wood and he just took a saw to it. I love Harrison. I got to stop him because I can make him laugh when he gets really, really mad.”',
    image:Falcon,
    imageType:'svg'
  }
]

export default facts
